import { useContext, useRef } from 'react';
import PropTypes from 'prop-types';

import { useOutsideClick } from '../../helpers/clickOutside';
import { ReactComponent as ArrowDownSVG } from '../../icons/arrow-down.svg';
import { ReactComponent as ArrowUpSVG } from '../../icons/arrow-up.svg';
import { UserContext } from '../../contexts/user';

import Dropdown from './dropdown';

import './aside.scss';

const DEFAULT_AVATAR_IMAGE = '/images/ghost.svg';

const ProfileItem = ({
  avatarUrl,
  onClick,
  onClickOutside,
  onSignOut,
  showDropdown,
}) => {
  const { user } = useContext(UserContext);
  const profileItemRef = useRef(null);

  useOutsideClick(profileItemRef, onClickOutside);

  return (
    <div
      className="th-nav-bottom"
      data-cy="profile-dropdown"
      onClick={onClick}
      ref={profileItemRef}
    >
      <div className="dropdown-trigger flex items-center outline-0 pointer space-between pa2 pl4 pr3">
        <div className="flex-auto flex items-center">
          <div
            className="th-user-avatar relative"
            style={{
              backgroundImage: `url(${avatarUrl || DEFAULT_AVATAR_IMAGE})`,
            }}
          />
          <div className="flex flex-column items-start justify-center">
            <span className="th-user-name mb1">{user.email}</span>
            <span className="th-user-email">
              {user.role === 'psadRep' ? user.treatingOrg.name : user.role}
            </span>
          </div>
        </div>
        {showDropdown ? (
          <ArrowDownSVG className="w3 mr1 fill-darkgrey" />
        ) : (
          <ArrowUpSVG className="w3 mr1 fill-darkgrey" />
        )}
      </div>
      {showDropdown && <Dropdown onSignOut={onSignOut} />}
    </div>
  );
};

ProfileItem.propTypes = {
  avatarUrl: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onClickOutside: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
  showDropdown: PropTypes.bool,
};

export default ProfileItem;
